import { createSelector } from '@reduxjs/toolkit'

import { selectMdfActivitiesState } from './selectMdfActivitiesState'

export const selectMdfActivitySavingIds = createSelector(
  [selectMdfActivitiesState],
  (state) => state.savingEntryIds
)
